import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShopSlash } from "@fortawesome/free-solid-svg-icons";

export default function DashboardUnavailable () {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <div className="text-center text-gray-600">
                <div className="text-4xl">
                    <FontAwesomeIcon icon={faShopSlash} />
                </div>
                <h1 className="text-4xl">
                    Your dashboard was not set.
                </h1>
                <p>
                    Contact the admin to setup your dashboard.
                </p>
            </div>
        </div>
    );
}